import { marked } from 'marked'
import React from 'react'

const Article = ({ block, data }: any) => {
  const parsedContent = marked.parse(data.Content)

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div
        className="article__content"
        dangerouslySetInnerHTML={{ __html: parsedContent }}
      ></div>
    </section>
  )
}

export default Article
